import { useEffect, useState } from 'react';
/**
 * Simple hook for utilizing `window.matchMedia`.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 *
 * @param {string} query - A mediaQueryString
 * @returns {boolean} - Returns a boolean indicating if the media matches.
 */
export const useMatchMedia = (query) => {
    const getMatch = () => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false);
    const [matches, setMatches] = useState(getMatch);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const media = window.matchMedia(query);
        const listener = () => setMatches(media.matches);
        setMatches(media.matches);
        media.addEventListener ? media.addEventListener('change', listener) : media.addListener(listener);
        /**
          * Cleanup function.
          */
        return () => media.removeEventListener ? media.removeEventListener('change', listener) : media.removeListener(listener);
    }, [query]);
    return matches;
};
